<template>
    <PopupRouterViewDetail label="Picking Supply For Production Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Picking Supply For Production" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="workOrderSupplys" optionsLabel="workOrderSupplyDate" optionsKey="id" label-cols-lg="12" label="Work Order Supply" id="fieldset-work-order-supply" size="sm" :model.sync="model.workOrderSupplyId"   :selected="model.workOrderSupply != null ? model.workOrderSupply.workOrderSupplyDate : ''" @input="getWorkOrderSupplys" @change="onWorkOrderSupplyChange"  :isUpdatable="true"  />
						<app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber" optionsKey="id" label-cols-lg="12" label="Work Order Process" id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"   :selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''" @input="getWorkOrderProcesss" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcess" />
						<app-input-datetimepicker id="fieldset-work-order-supply-date" label-cols-lg="12"  label="Work Order Supply Date" size="sm" :model.sync="model.workOrderSupplyDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="true" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line" id="fieldset-line" size="sm" :model.sync="model.lineId"   :selected="model.line != null ? model.line.code : ''" @input="getLines" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedLine" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="PickingSupplyForProductionDetail" :bordered="true" :items="pickingSupplyForProductionDetails" :fields="fieldsPickingSupplyForProductionDetail" :busy="isDataLoading" :sort-by.sync="sortByPickingSupplyForProductionDetail" :sort-desc.sync="sortDescPickingSupplyForProductionDetail" small responsive
			@editButtonMethod="editRowDataPickingSupplyForProductionDetail"
			@deleteButtonMethod="deleteRowDataPickingSupplyForProductionDetail"
			@showPopupAddMethod="resetDataPickingSupplyForProductionDetail()"
			@showPopupUploadMethod="showPopupUploadPickingSupplyForProductionDetail()"
			@downloadMethod="downloadPickingSupplyForProductionDetail()"
			@addFromClipboardMethod="addFromClipboardPickingSupplyForProductionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingSupplyForProductionDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadPickingSupplyForProductionDetail"
			>
			<template #top-row v-if="isShowPickingSupplyForProductionDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Material Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterPickingSupplyForProductionDetail.materialPartId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionDetail.materialPartId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterPickingSupplyForProductionDetail.partId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Supply">
					<b-form-input id="input-qty-supply-table" v-model="filterPickingSupplyForProductionDetail.qtySupply" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Outstanding">
					<b-form-input id="input-qty-outstanding-table" v-model="filterPickingSupplyForProductionDetail.qtyOutstanding" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-remark-table" v-model="filterPickingSupplyForProductionDetail.remark" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="DocumentStatus">
					<v-select append-to-body label="name" :options="documentStatuss"  :value="filterPickingSupplyForProductionDetail.documentStatusId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionDetail.documentStatusId" @search="getDocumentStatuss" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Work Order Supply Detail">
					<v-select append-to-body label="materialPart" :options="workOrderSupplyDetails"  :value="filterPickingSupplyForProductionDetail.workOrderSupplyDetailId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionDetail.workOrderSupplyDetailId" @search="getWorkOrderSupplyDetails" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingSupplyForProductionDetailPageSize * (currentPickingSupplyForProductionDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(materialPart)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-production-detail-material-part-' + row.index" label-cols-lg="12" label="Material Part" size="sm" :model.sync="row.item.materialPartId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.materialPart != null ? row.item.materialPart.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-production-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtySupply)="row">
				<app-input-textbox :id="'input-picking-supply-for-production-detail-qty-supply-' + row.index" label-cols-lg="12" label="Qty Supply" size="sm" :model.sync="row.item.qtySupply"   @change="saveInputPickingSupplyForProductionDetail(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyOutstanding)="row">
				<app-input-textbox :id="'input-picking-supply-for-production-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputPickingSupplyForProductionDetail(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-picking-supply-for-production-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPickingSupplyForProductionDetail(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-picking-supply-for-production-detail-document-status-' + row.index" label-cols-lg="12" label="DocumentStatus" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(workOrderSupplyDetail)="row">
				<app-input-combobox-autocomplete :options="workOrderSupplyDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-picking-supply-for-production-detail-work-order-supply-detail-' + row.index" label-cols-lg="12" label="Work Order Supply Detail" size="sm" :model.sync="row.item.workOrderSupplyDetailId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.workOrderSupplyDetail != null ? row.item.workOrderSupplyDetail.materialPart : ''"  @input="getWorkOrderSupplyDetails" :loading="isWorkOrderSupplyDetailComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<PickingSupplyForProductionDetailInput 
					:openPopup="isShowPopupPickingSupplyForProductionDetail"
					:modelId="pickingSupplyForProductionDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingSupplyForProductionDetail"/>
			</template>
			<template v-slot:upload-detail>
				<PickingSupplyForProductionDetailUpload
					:openPopup="isShowPopupUploadPickingSupplyForProductionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingSupplyForProductionDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-production-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-production-detail-qty-supply-' + row.index" label-cols-lg="12" label="Qty Supply" size="sm" :model.sync="row.item.qtySupply"   @change="saveInputPickingSupplyForProductionDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-production-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputPickingSupplyForProductionDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textarea :id="'input-picking-supply-for-production-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-picking-supply-for-production-detail-document-status-' + row.index" label-cols-lg="12" label="DocumentStatus" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="workOrderSupplyDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-picking-supply-for-production-detail-work-order-supply-detail-' + row.index" label-cols-lg="12" label="Work Order Supply Detail" size="sm" :model.sync="row.item.workOrderSupplyDetailId"  @change="saveInputPickingSupplyForProductionDetail(row.item)" :selected="row.item.workOrderSupplyDetail != null ? row.item.workOrderSupplyDetail.materialPart : ''"  @input="getWorkOrderSupplyDetails" :loading="isWorkOrderSupplyDetailComboLoading"  :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
		<app-table-input-popup title="Picking Supply For Production Case" :bordered="true" :items="pickingSupplyForProductionCases" :fields="fieldsPickingSupplyForProductionCase" :busy="isDataLoading" :sort-by.sync="sortByPickingSupplyForProductionCase" :sort-desc.sync="sortDescPickingSupplyForProductionCase" small responsive
			@editButtonMethod="editRowDataPickingSupplyForProductionCase"
			@deleteButtonMethod="deleteRowDataPickingSupplyForProductionCase"
			@showPopupAddMethod="resetDataPickingSupplyForProductionCase()"
			@showPopupUploadMethod="showPopupUploadPickingSupplyForProductionCase()"
			@downloadMethod="downloadPickingSupplyForProductionCase()"
			@addFromClipboardMethod="addFromClipboardPickingSupplyForProductionCase()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingSupplyForProductionCase()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadPickingSupplyForProductionCase"
			>
			<template #top-row v-if="isShowPickingSupplyForProductionCaseFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Picking Supply For Production Detail">
					<v-select append-to-body label="materialPart" :options="pickingSupplyForProductionDetails"  :value="filterPickingSupplyForProductionCase.pickingSupplyForProductionDetailId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionCase.pickingSupplyForProductionDetailId" @search="getPickingSupplyForProductionDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterPickingSupplyForProductionCase.controlCardId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionCase.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterPickingSupplyForProductionCase.partId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionCase.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-qty-table" v-model="filterPickingSupplyForProductionCase.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-remark-table" v-model="filterPickingSupplyForProductionCase.remark" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Document Status">
					<v-select append-to-body label="name" :options="documentStatuss"  :value="filterPickingSupplyForProductionCase.documentStatusId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionCase.documentStatusId" @search="getDocumentStatuss" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingSupplyForProductionCasePageSize * (currentPickingSupplyForProductionCasePage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(pickingSupplyForProductionDetail)="row">
				<app-input-combobox-autocomplete :options="pickingSupplyForProductionDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-picking-supply-for-production-case-picking-supply-for-production-detail-' + row.index" label-cols-lg="12" label="Picking Supply For Production Detail" size="sm" :model.sync="row.item.pickingSupplyForProductionDetailId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.pickingSupplyForProductionDetail != null ? row.item.pickingSupplyForProductionDetail.materialPart : ''"  @input="getPickingSupplyForProductionDetails" :loading="isPickingSupplyForProductionDetailComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-supply-for-production-case-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-production-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-picking-supply-for-production-case-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPickingSupplyForProductionCase(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-picking-supply-for-production-case-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPickingSupplyForProductionCase(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(documentStatus)="row">
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-picking-supply-for-production-case-document-status-' + row.index" label-cols-lg="12" label="Document Status" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<PickingSupplyForProductionCaseInput 
					:openPopup="isShowPopupPickingSupplyForProductionCase"
					:modelId="pickingSupplyForProductionCaseId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingSupplyForProductionCase"/>
			</template>
			<template v-slot:upload-detail>
				<PickingSupplyForProductionCaseUpload
					:openPopup="isShowPopupUploadPickingSupplyForProductionCase"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingSupplyForProductionCase"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-supply-for-production-case-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-production-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-production-case-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPickingSupplyForProductionCase(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textarea :id="'input-picking-supply-for-production-case-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputPickingSupplyForProductionCase(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" :id="'input-picking-supply-for-production-case-document-status-' + row.index" label-cols-lg="12" label="Document Status" size="sm" :model.sync="row.item.documentStatusId"  @change="saveInputPickingSupplyForProductionCase(row.item)" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''"  @input="getDocumentStatuss" :loading="isDocumentStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
		<app-table-input-popup title="Picking Supply For Production Suggestion" :bordered="true" :items="pickingSupplyForProductionSuggestions" :fields="fieldsPickingSupplyForProductionSuggestion" :busy="isDataLoading" :sort-by.sync="sortByPickingSupplyForProductionSuggestion" :sort-desc.sync="sortDescPickingSupplyForProductionSuggestion" small responsive
			@editButtonMethod="editRowDataPickingSupplyForProductionSuggestion"
			@deleteButtonMethod="deleteRowDataPickingSupplyForProductionSuggestion"
			@showPopupAddMethod="resetDataPickingSupplyForProductionSuggestion()"
			@showPopupUploadMethod="showPopupUploadPickingSupplyForProductionSuggestion()"
			@downloadMethod="downloadPickingSupplyForProductionSuggestion()"
			@addFromClipboardMethod="addFromClipboardPickingSupplyForProductionSuggestion()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingSupplyForProductionSuggestion()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadPickingSupplyForProductionSuggestion"
			>
			<template #top-row v-if="isShowPickingSupplyForProductionSuggestionFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Picking Supply For Production Detail">
					<v-select append-to-body label="materialPart" :options="pickingSupplyForProductionDetails"  :value="filterPickingSupplyForProductionSuggestion.pickingSupplyForProductionDetailId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionSuggestion.pickingSupplyForProductionDetailId" @search="getPickingSupplyForProductionDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterPickingSupplyForProductionSuggestion.controlCardId" :reduce="item => item.id" v-model="filterPickingSupplyForProductionSuggestion.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-qty-table" v-model="filterPickingSupplyForProductionSuggestion.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Picking">
					<b-form-checkbox id="input-is-picking-table" class="float-right" v-model="filterPickingSupplyForProductionSuggestion.isPicking"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingSupplyForProductionSuggestionPageSize * (currentPickingSupplyForProductionSuggestionPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(pickingSupplyForProductionDetail)="row">
				<app-input-combobox-autocomplete :options="pickingSupplyForProductionDetails" optionsLabel="materialPart" optionsKey="id" :id="'input-picking-supply-for-production-suggestion-picking-supply-for-production-detail-' + row.index" label-cols-lg="12" label="Picking Supply For Production Detail" size="sm" :model.sync="row.item.pickingSupplyForProductionDetailId"  @change="saveInputPickingSupplyForProductionSuggestion(row.item)" :selected="row.item.pickingSupplyForProductionDetail != null ? row.item.pickingSupplyForProductionDetail.materialPart : ''"  @input="getPickingSupplyForProductionDetails" :loading="isPickingSupplyForProductionDetailComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-supply-for-production-suggestion-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingSupplyForProductionSuggestion(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-picking-supply-for-production-suggestion-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPickingSupplyForProductionSuggestion(row.item)"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(isPicking)="row">
				<app-input-checkbox :id="'input-picking-supply-for-production-suggestion-is-picking-row-' + row.index" label-cols-lg="12" label="Is Picking" :model.sync="row.item.isPicking" @change="saveInputPickingSupplyForProductionSuggestion(row.item)"  :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>

			<template v-slot:form-add-detail>
				<PickingSupplyForProductionSuggestionInput 
					:openPopup="isShowPopupPickingSupplyForProductionSuggestion"
					:modelId="pickingSupplyForProductionSuggestionId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingSupplyForProductionSuggestion"/>
			</template>
			<template v-slot:upload-detail>
				<PickingSupplyForProductionSuggestionUpload
					:openPopup="isShowPopupUploadPickingSupplyForProductionSuggestion"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingSupplyForProductionSuggestion"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-supply-for-production-suggestion-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingSupplyForProductionSuggestion(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-production-suggestion-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputPickingSupplyForProductionSuggestion(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-checkbox :id="'input-picking-supply-for-production-suggestion-is-picking-row-' + row.index" label-cols-lg="12" label="Is Picking" :model.sync="row.item.isPicking" @change="saveInputPickingSupplyForProductionSuggestion(row.item)" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionList from '@/models/PickingSupplyForProduction/PickingSupplyForProductionList';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import PickingSupplyForProductionCase from '@/models/PickingSupplyForProduction/PickingSupplyForProductionCase';
import PickingSupplyForProductionCaseFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionCaseFilter';
import PickingSupplyForProductionSuggestion from '@/models/PickingSupplyForProduction/PickingSupplyForProductionSuggestion';
import PickingSupplyForProductionSuggestionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionSuggestionFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingSupplyForProductionDetailInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionDetailInput';
import PickingSupplyForProductionDetailUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PickingSupplyForProductionCaseInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionCaseInput';
import PickingSupplyForProductionCaseUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionCaseUpload';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PickingSupplyForProductionSuggestionInput from '@/views/PickingSupplyForProduction/PickingSupplyForProductionSuggestionInput';
import PickingSupplyForProductionSuggestionUpload from '@/views/PickingSupplyForProduction/PickingSupplyForProductionSuggestionUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PickingSupplyForProductionDetailInput,PickingSupplyForProductionDetailUpload,
		PickingSupplyForProductionCaseInput,PickingSupplyForProductionCaseUpload,
		AppInputCheckbox,
		PickingSupplyForProductionSuggestionInput,PickingSupplyForProductionSuggestionUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingSupplyForProductionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"materialPart": { "class" : "th-material-part first-child", "label" : "Material Part", key: 'materialPart', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtySupply": { "class" : "th-qty-supply last-child", "label" : "Qty Supply", key: 'qtySupply', sortable: false}}, 
				{"qtyOutstanding": { "class" : "th-qty-outstanding d-stack-none", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "DocumentStatus", key: 'documentStatus', sortable: false}}, 
				{"workOrderSupplyDetail": { "class" : "th-work-order-supply-detail d-stack-none", "label" : "Work Order Supply Detail", key: 'workOrderSupplyDetail', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingSupplyForProductionCase: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"pickingSupplyForProductionDetail": { "class" : "th-picking-supply-for-production-detail first-child", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: false}}, 
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingSupplyForProductionSuggestion: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"pickingSupplyForProductionDetail": { "class" : "th-picking-supply-for-production-detail first-child", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"qty": { "class" : "th-qty last-child", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"isPicking": { "class" : "th-is-picking d-stack-none", "label" : "Is Picking", key: 'isPicking', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPickingSupplyForProductionDetail : {},
			isShowPopupPickingSupplyForProductionDetail : false,
			isShowPopupUploadPickingSupplyForProductionDetail : false,
			modelPickingSupplyForProductionCase : {},
			isShowPopupPickingSupplyForProductionCase : false,
			isShowPopupUploadPickingSupplyForProductionCase : false,
			modelPickingSupplyForProductionSuggestion : {},
			isShowPopupPickingSupplyForProductionSuggestion : false,
			isShowPopupUploadPickingSupplyForProductionSuggestion : false,
			filterPickingSupplyForProduction : null,
			currentPickingSupplyForProductionPage : 1,
			pickingSupplyForProductionPageSize: 10,
			sortByPickingSupplyForProduction: '',
			sortDescPickingSupplyForProduction: '',
			filterPickingSupplyForProductionDetail : null,
			currentPickingSupplyForProductionDetailPage : 1,
			pickingSupplyForProductionDetailPageSize: 10,
			sortByPickingSupplyForProductionDetail: '',
			sortDescPickingSupplyForProductionDetail: '',
			sortingByPickingSupplyForProductionDetail: [],
			pickingSupplyForProductionDetails : [],
			pickingSupplyForProductionDetailId : '',
			totalPickingSupplyForProductionDetailRow : 0,
			isShowPickingSupplyForProductionDetailFilter: false,
			isDownloadPickingSupplyForProductionDetail: false,
			filterPickingSupplyForProductionCase : null,
			currentPickingSupplyForProductionCasePage : 1,
			pickingSupplyForProductionCasePageSize: 10,
			sortByPickingSupplyForProductionCase: '',
			sortDescPickingSupplyForProductionCase: '',
			sortingByPickingSupplyForProductionCase: [],
			pickingSupplyForProductionCases : [],
			pickingSupplyForProductionCaseId : '',
			totalPickingSupplyForProductionCaseRow : 0,
			isShowPickingSupplyForProductionCaseFilter: false,
			isDownloadPickingSupplyForProductionCase: false,
			filterPickingSupplyForProductionSuggestion : null,
			currentPickingSupplyForProductionSuggestionPage : 1,
			pickingSupplyForProductionSuggestionPageSize: 10,
			sortByPickingSupplyForProductionSuggestion: '',
			sortDescPickingSupplyForProductionSuggestion: '',
			sortingByPickingSupplyForProductionSuggestion: [],
			pickingSupplyForProductionSuggestions : [],
			pickingSupplyForProductionSuggestionId : '',
			totalPickingSupplyForProductionSuggestionRow : 0,
			isShowPickingSupplyForProductionSuggestionFilter: false,
			isDownloadPickingSupplyForProductionSuggestion: false,
			parts: [],
			documentStatuss: [],
			workOrderSupplyDetails: [],
			pickingSupplyForProductionDetails: [],
			controlCards: [],
			workOrderSupplys: [],
			workOrderSupplys: [],
			isWorkOrderSupplyComboLoading: false,
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			lines: [],
			lines: [],
			isLineComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderSupplyComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isDocumentStatusComboLoading: false,
			isLineComboLoading: false,
			isPickingSupplyForProductionComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderSupplyDetailComboLoading: false,
			isPickingSupplyForProductionDetailComboLoading: false,
			isControlCardComboLoading: false,
		}
	},
	methods : {
		getPickingSupplyForProduction : async function(id) {
			this.isBusy = true;
			PickingSupplyForProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPickingSupplyForProduction = true;
			this.filterPickingSupplyForProduction.id = this.modelId;
			PickingSupplyForProduction.downloadDataDetail(this, this.filterPickingSupplyForProduction).then(result => {
				this.isDownloadPickingSupplyForProduction = false;
			}).catch(error => { this.isDownloadPickingSupplyForProduction = false; })
		},
		getPickingSupplyForProductionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPickingSupplyForProductionDetail);
			if (this.modelId == null) return;
			filter.pickingSupplyForProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingSupplyForProductionDetail != null) {
				this.sortingByPickingSupplyForProductionDetail[this.sortByPickingSupplyForProductionDetail] = this.sortDescPickingSupplyForProductionDetail;
			}
			let currentPage = (this.currentPickingSupplyForProductionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingSupplyForProductionDetailRow + 1;
				let page = Math.ceil(totalData/this.pickingSupplyForProductionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.pickingSupplyForProductionDetailPageSize = 0;
			// disable paging end
			PickingSupplyForProductionDetail.getList(this, filter, this.sortingByPickingSupplyForProductionDetail, currentPage , this.pickingSupplyForProductionDetailPageSize).then(result => {
				this.currentPickingSupplyForProductionDetailPage = currentPage + 1;
				this.pickingSupplyForProductionDetails = result.data;
				this.totalPickingSupplyForProductionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPickingSupplyForProductionCases : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPickingSupplyForProductionCase);
			if (this.modelId == null) return;
			filter.pickingSupplyForProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingSupplyForProductionCase != null) {
				this.sortingByPickingSupplyForProductionCase[this.sortByPickingSupplyForProductionCase] = this.sortDescPickingSupplyForProductionCase;
			}
			let currentPage = (this.currentPickingSupplyForProductionCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingSupplyForProductionCaseRow + 1;
				let page = Math.ceil(totalData/this.pickingSupplyForProductionCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.pickingSupplyForProductionCasePageSize = 0;
			// disable paging end
			PickingSupplyForProductionCase.getList(this, filter, this.sortingByPickingSupplyForProductionCase, currentPage , this.pickingSupplyForProductionCasePageSize).then(result => {
				this.currentPickingSupplyForProductionCasePage = currentPage + 1;
				this.pickingSupplyForProductionCases = result.data;
				this.totalPickingSupplyForProductionCaseRow = result.dataCount;
			}).catch(error => {});
		},
		getPickingSupplyForProductionSuggestions : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPickingSupplyForProductionSuggestion);
			if (this.modelId == null) return;
			filter.pickingSupplyForProductionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingSupplyForProductionSuggestion != null) {
				this.sortingByPickingSupplyForProductionSuggestion[this.sortByPickingSupplyForProductionSuggestion] = this.sortDescPickingSupplyForProductionSuggestion;
			}
			let currentPage = (this.currentPickingSupplyForProductionSuggestionPage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingSupplyForProductionSuggestionRow + 1;
				let page = Math.ceil(totalData/this.pickingSupplyForProductionSuggestionPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.pickingSupplyForProductionSuggestionPageSize = 0;
			// disable paging end
			PickingSupplyForProductionSuggestion.getList(this, filter, this.sortingByPickingSupplyForProductionSuggestion, currentPage , this.pickingSupplyForProductionSuggestionPageSize).then(result => {
				this.currentPickingSupplyForProductionSuggestionPage = currentPage + 1;
				this.pickingSupplyForProductionSuggestions = result.data;
				this.totalPickingSupplyForProductionSuggestionRow = result.dataCount;
			}).catch(error => {});
		},
		getPickingSupplyForProductions : async function(input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.WorkOrderSupply = input;
			}
			this.isPickingSupplyForProductionComboLoading = true;
			PickingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
				}
				this.isPickingSupplyForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getPickingSupplyForProductions : async function(input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.workOrderSupply = input;
			}
			this.isPickingSupplyForProductionComboLoading = true;
			PickingSupplyForProduction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductions = result.data
				}
				this.isPickingSupplyForProductionComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplyDetails : async function(input) {
			let filter = new WorkOrderSupplyDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			this.isWorkOrderSupplyDetailComboLoading = true;
			WorkOrderSupplyDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplyDetails = result.data
				}
				this.isWorkOrderSupplyDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getPickingSupplyForProductionDetails : async function(input) {
			let filter = new PickingSupplyForProductionDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			this.isPickingSupplyForProductionDetailComboLoading = true;
			PickingSupplyForProductionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForProductionDetails = result.data
				}
				this.isPickingSupplyForProductionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplys : async function(input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			WorkOrderSupply.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderSupplyExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.workOrderSupplyId = null;
				this.model.workOrderSupply = null;
				this.isBusy = true;
				PickingSupplyForProduction.resetDocument(this, this.model.id).then(result => {
					this.getPickingSupplyForProduction(this.model.id).then(result => {
						this.getPickingSupplyForProductionDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.workOrderSupplyId = item.id;
				this.model.workOrderSupply = item;

				this.isBusy = true;
				PickingSupplyForProduction.copyFromDocument(this, 'workordersupply', item.id, this.model.id).then(result => {
					this.getPickingSupplyForProduction(this.model.id).then(result => {
						this.getPickingSupplyForProductionDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedWorkOrderSupply(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.workOrderSupplyId == itemId) return;
			}

			if(this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Picking Supply For Production akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedWorkOrderSupplyExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedWorkOrderSupplyExecuted(item);
			}
		},
		onWorkOrderSupplyChange : async function() {
			this.model.workOrderProcessId = null;
			this.model.workOrderProcess = null;

			let item = this.model.workOrderSupplyId;
			let workOrderSupplyObj = this.workOrderSupplys.filter(function(workOrderSupply){ return workOrderSupply.id == item; });
			this.model.workOrderSupply = workOrderSupplyObj.length > 0 ? workOrderSupplyObj[0] : null;
			this.getWorkOrderProcessByWorkOrderSupply();
		},
		getWorkOrderProcessByWorkOrderSupply : async function(input) {
			this.workOrderProcessState = false;
			this.$forceUpdate();

			let filter = new WorkOrderProcessFilter();
			filter.workOrderSupplyId = this.model.workOrderSupplyId;
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			if (filter.workOrderSupplyId === undefined || filter.workOrderSupplyId === null || filter.workOrderSupplyId === '') {
				this.workOrderProcesss = [];
			} else {
				WorkOrderProcess.getList(this, filter, null, 0, 10)
					.then(result => {
						this.workOrderProcesss = [];
						if (result != null) {
							this.workOrderProcesss = result.data
						}
					})
					.catch(error => {
						this.workOrderProcesss = [];
					});
			}

			this.workOrderProcessState = true;
			this.$forceUpdate();
		},

		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcess(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLine(item) {
			if(item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingSupplyForProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PickingSupplyForProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProduction.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPickingSupplyForProduction(id);
					});
				}
			});
		},
		onHidden() {
			this.getPickingSupplyForProductions();
		},
		addRowDataPickingSupplyForProductionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionDetails(true);
						this.isShowPopupPickingSupplyForProductionDetail = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionDetails(true);
						this.isShowPopupPickingSupplyForProductionDetail = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionDetail(id) {
			this.pickingSupplyForProductionDetailId = id;
			this.isShowPopupPickingSupplyForProductionDetail = true; 
		},
		async deleteRowDataPickingSupplyForProductionDetail(id) {
			PickingSupplyForProductionDetail.deleteData(this, id).then(result => { this.getPickingSupplyForProductionDetails(); });
		},
		async resetDataPickingSupplyForProductionDetail() {
			this.pickingSupplyForProductionDetailId = "";
			this.isShowPopupPickingSupplyForProductionDetail = true;
		},
		async addDataPickingSupplyForProductionDetail() {
			PickingSupplyForProductionDetail.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionDetails(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionDetail.addFromClipboard(this, materialParts).then(result => { this.getPickingSupplyForProductionDetails() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionDetail.replaceFromClipboard(this, materialParts).then(result => { this.getPickingSupplyForProductionDetails() });
			});   
		},
		showPopupUploadPickingSupplyForProductionDetail() {
			if(this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingSupplyForProductionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingSupplyForProductionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingSupplyForProductionDetail = true;
			}
		},
		uploadDataPickingSupplyForProductionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionDetail = false; 
		},
		downloadPickingSupplyForProductionDetail(modalEvent) {
			this.isDownloadPickingSupplyForProductionDetail = true;
			this.filterPickingSupplyForProductionDetail.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionDetail.downloadDataDetail(this, this.filterPickingSupplyForProductionDetail).then(result => {
				this.isDownloadPickingSupplyForProductionDetail = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionDetail = false; })
		},
		saveInputPickingSupplyForProductionDetail(item) {
			if (this.pickingSupplyForProductions != null && this.pickingSupplyForProductions != undefined  && this.pickingSupplyForProductions.length > 0) {
				item.pickingSupplyForProduction = this.pickingSupplyForProductions.find(q => q.id == item.pickingSupplyForProductionId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.materialPart = this.parts.find(q => q.id == item.materialPartId);
			}
			if (this.documentStatuss != null && this.documentStatuss != undefined  && this.documentStatuss.length > 0) {
				item.documentStatus = this.documentStatuss.find(q => q.id == item.documentStatusId);
			}
			if (this.workOrderSupplyDetails != null && this.workOrderSupplyDetails != undefined  && this.workOrderSupplyDetails.length > 0) {
				item.workOrderSupplyDetail = this.workOrderSupplyDetails.find(q => q.id == item.workOrderSupplyDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataPickingSupplyForProductionCase(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionCase.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionCases(true);
						this.isShowPopupPickingSupplyForProductionCase = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionCase.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionCases(true);
						this.isShowPopupPickingSupplyForProductionCase = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionCase(id) {
			this.pickingSupplyForProductionCaseId = id;
			this.isShowPopupPickingSupplyForProductionCase = true; 
		},
		async deleteRowDataPickingSupplyForProductionCase(id) {
			PickingSupplyForProductionCase.deleteData(this, id).then(result => { this.getPickingSupplyForProductionCases(); });
		},
		async resetDataPickingSupplyForProductionCase() {
			this.pickingSupplyForProductionCaseId = "";
			this.isShowPopupPickingSupplyForProductionCase = true;
		},
		async addDataPickingSupplyForProductionCase() {
			PickingSupplyForProductionCase.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionCases(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionCase.addFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionCases() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionCase() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionCase.replaceFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionCases() });
			});   
		},
		showPopupUploadPickingSupplyForProductionCase() {
			if(this.pickingSupplyForProductionCases != null && this.pickingSupplyForProductionCases.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingSupplyForProductionCase akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingSupplyForProductionCase = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingSupplyForProductionCase = true;
			}
		},
		uploadDataPickingSupplyForProductionCase(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionCase = false; 
		},
		downloadPickingSupplyForProductionCase(modalEvent) {
			this.isDownloadPickingSupplyForProductionCase = true;
			this.filterPickingSupplyForProductionCase.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionCase.downloadDataDetail(this, this.filterPickingSupplyForProductionCase).then(result => {
				this.isDownloadPickingSupplyForProductionCase = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionCase = false; })
		},
		saveInputPickingSupplyForProductionCase(item) {
			if (this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails != undefined  && this.pickingSupplyForProductionDetails.length > 0) {
				item.pickingSupplyForProductionDetail = this.pickingSupplyForProductionDetails.find(q => q.id == item.pickingSupplyForProductionDetailId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionCase.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataPickingSupplyForProductionSuggestion(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionSuggestion.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForProductionSuggestions(true);
						this.isShowPopupPickingSupplyForProductionSuggestion = false;
					})
				} else {
					model.pickingSupplyForProductionId =  this.modelId;
					PickingSupplyForProductionSuggestion.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForProductionSuggestions(true);
						this.isShowPopupPickingSupplyForProductionSuggestion = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForProductionSuggestion(id) {
			this.pickingSupplyForProductionSuggestionId = id;
			this.isShowPopupPickingSupplyForProductionSuggestion = true; 
		},
		async deleteRowDataPickingSupplyForProductionSuggestion(id) {
			PickingSupplyForProductionSuggestion.deleteData(this, id).then(result => { this.getPickingSupplyForProductionSuggestions(); });
		},
		async resetDataPickingSupplyForProductionSuggestion() {
			this.pickingSupplyForProductionSuggestionId = "";
			this.isShowPopupPickingSupplyForProductionSuggestion = true;
		},
		async addDataPickingSupplyForProductionSuggestion() {
			PickingSupplyForProductionSuggestion.createData(this, { pickingSupplyForProductionId: this.modelId })
			.then(result => {
				this.getPickingSupplyForProductionSuggestions(true);
			})
		},
		async addFromClipboardPickingSupplyForProductionSuggestion() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionSuggestion.addFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionSuggestions() });
			});
		},
		async replaceFromClipboardPickingSupplyForProductionSuggestion() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, pickingSupplyForProductionId: this.modelId });
				});
				PickingSupplyForProductionSuggestion.replaceFromClipboard(this, controlCards).then(result => { this.getPickingSupplyForProductionSuggestions() });
			});   
		},
		showPopupUploadPickingSupplyForProductionSuggestion() {
			if(this.pickingSupplyForProductionSuggestions != null && this.pickingSupplyForProductionSuggestions.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingSupplyForProductionSuggestion akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingSupplyForProductionSuggestion = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingSupplyForProductionSuggestion = true;
			}
		},
		uploadDataPickingSupplyForProductionSuggestion(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForProductionSuggestion = false; 
		},
		downloadPickingSupplyForProductionSuggestion(modalEvent) {
			this.isDownloadPickingSupplyForProductionSuggestion = true;
			this.filterPickingSupplyForProductionSuggestion.pickingSupplyForProductionId = this.modelId;
			PickingSupplyForProductionSuggestion.downloadDataDetail(this, this.filterPickingSupplyForProductionSuggestion).then(result => {
				this.isDownloadPickingSupplyForProductionSuggestion = false;
			}).catch(error => { this.isDownloadPickingSupplyForProductionSuggestion = false; })
		},
		saveInputPickingSupplyForProductionSuggestion(item) {

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForProductionSuggestion.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingSupplyForProductionDetail = false; 
			this.isShowPopupPickingSupplyForProductionDetail = false; 
			if (modalType == 'PickingSupplyForProductionDetail') {
				this.getPickingSupplyForProductionDetails();
			}
			this.isShowPopupUploadPickingSupplyForProductionCase = false; 
			this.isShowPopupPickingSupplyForProductionCase = false; 
			if (modalType == 'PickingSupplyForProductionCase') {
				this.getPickingSupplyForProductionCases();
			}
			this.isShowPopupUploadPickingSupplyForProductionSuggestion = false; 
			this.isShowPopupPickingSupplyForProductionSuggestion = false; 
			if (modalType == 'PickingSupplyForProductionSuggestion') {
				this.getPickingSupplyForProductionSuggestions();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPickingSupplyForProductionDetailFilter = true;
				//this.isShowPickingSupplyForProductionCaseFilter = true;
				//this.isShowPickingSupplyForProductionSuggestionFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPickingSupplyForProduction = new PickingSupplyForProductionFilter();
		this.filterPickingSupplyForProductionDetail = new PickingSupplyForProductionDetailFilter();
		this.filterPickingSupplyForProductionCase = new PickingSupplyForProductionCaseFilter();
		this.filterPickingSupplyForProductionSuggestion = new PickingSupplyForProductionSuggestionFilter();
		//this.getPickingSupplyForProductions();
		//this.getParts();
		//this.getDocumentStatuss();
		//this.getWorkOrderSupplyDetails();
		//this.getPickingSupplyForProductionDetails();
		//this.getControlCards();
		//this.getWorkOrderSupplys();
		//this.getWorkOrderProcesss();
		//this.getLines();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPickingSupplyForProduction(id);
			} else {
				this.modelId = id;
				this.getPickingSupplyForProduction(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByPickingSupplyForProductionDetail : {
			handler: function() {
				this.getPickingSupplyForProductionDetails();
			}
		},
		sortDescPickingSupplyForProductionDetail: {
			handler: function() {
				this.getPickingSupplyForProductionDetails();
			}
		},
		currentPickingSupplyForProductionDetailPage: {
			handler: function() {
				this.getPickingSupplyForProductionDetails();
			}
		},
		pickingSupplyForProductionDetailPageSize : {
			handler: function() {
				this.getPickingSupplyForProductionDetails();
			}
		},
		filterPickingSupplyForProductionDetail: {
			handler: function() {
				this.getPickingSupplyForProductionDetails();
			},
			deep: true,
		},
		sortByPickingSupplyForProductionCase : {
			handler: function() {
				this.getPickingSupplyForProductionCases();
			}
		},
		sortDescPickingSupplyForProductionCase: {
			handler: function() {
				this.getPickingSupplyForProductionCases();
			}
		},
		currentPickingSupplyForProductionCasePage: {
			handler: function() {
				this.getPickingSupplyForProductionCases();
			}
		},
		pickingSupplyForProductionCasePageSize : {
			handler: function() {
				this.getPickingSupplyForProductionCases();
			}
		},
		filterPickingSupplyForProductionCase: {
			handler: function() {
				this.getPickingSupplyForProductionCases();
			},
			deep: true,
		},
		sortByPickingSupplyForProductionSuggestion : {
			handler: function() {
				this.getPickingSupplyForProductionSuggestions();
			}
		},
		sortDescPickingSupplyForProductionSuggestion: {
			handler: function() {
				this.getPickingSupplyForProductionSuggestions();
			}
		},
		currentPickingSupplyForProductionSuggestionPage: {
			handler: function() {
				this.getPickingSupplyForProductionSuggestions();
			}
		},
		pickingSupplyForProductionSuggestionPageSize : {
			handler: function() {
				this.getPickingSupplyForProductionSuggestions();
			}
		},
		filterPickingSupplyForProductionSuggestion: {
			handler: function() {
				this.getPickingSupplyForProductionSuggestions();
			},
			deep: true,
		},
	},
}
</script>
